/* eslint-disable no-undef */

import api from '../api'
import vue from 'vue'
import utils from '../utils/utils'

export const GET_PERIODS = 'GET_PERIODS'
export const UPDATE_MENU_DISHES = 'UPDATE_MENU_DISHES'
export const CHANGE_DISH_COUNT = 'CHANGE_DISH_COUNT'
export const ALL_PERIOD_PLAN_DISHES = 'allPeriodPlanDishes_v4'
export const COMMIT_ORDER = 'COMMIT_ORDER'
export const CLEAR_ORDERED_DISH_BY_PERIOD_ID = 'CLEAR_ORDERED_DISH_BY_PERIOD_ID'
export default {
  state: {allPeriods: [], allDishes: JSON.parse(sessionStorage.getItem(ALL_PERIOD_PLAN_DISHES)) || {}, discountDic: {}},
  mutations: {
    [GET_PERIODS] (state, periods) {
      Object.assign(state, periods)
    },
    [UPDATE_MENU_DISHES] (state, data) {
      vue.set(state.allDishes, data.periodPlanId + '', data.data)
      vue.set(state.discountDic, data.periodPlanId + '', data.discountDic)
      sessionStorage.setItem(ALL_PERIOD_PLAN_DISHES, JSON.stringify(state.allDishes))
    }
  },
  actions: {
    getSelectedDish ({commit, state}, periodPlanId) {
      return new Promise(function (resolve, reject) {
        console.log(state)
        let selectedDish = []
        if (state.allDishes[periodPlanId]['dishes'] === undefined || !Array.isArray(state.allDishes[periodPlanId]['dishes'])) return []
        state.allDishes[periodPlanId]['dishes'].forEach(cate => {
          cate.items.forEach(dish => {
            if (dish.count > 0) {
              selectedDish.push(dish)
            }
          })
        })
        resolve(JSON.parse(JSON.stringify(selectedDish)))
      }, (data) => {
        reject(data)
      })
    },
    // 获取餐段
    [GET_PERIODS] ({commit}, user) {
      return new Promise(function (resolve, reject) {
        api.getPeriods(user).then((data) => {
          commit(GET_PERIODS, data)
          resolve()
        }, (data) => {
          commit(GET_PERIODS, {})
          reject(data)
        })
      })
    },
    // 更新菜单
    // param: {user:  , hallId:  , periodPlanId:  }
    [UPDATE_MENU_DISHES] ({state, commit}, param) {
      return new Promise(function (resolve, reject) {
        api.getPeriodMenus(param.user, param.hallId, param.periodPlanId).then(data => {
          let discounts = data.discounts
          // 按照类目优先级排序
          let dishes = data.cates.sort((a, b) => {
            return a.catePriority - b.catePriority
          })
          // 最少点的菜直接点上 / 加上 cateIndex,dishIndex,periodPlanId
          dishes.forEach((cate, cateIndex) => {
            cate.items.forEach((dish, dishIndex) => {
              dish.cateIndex = cateIndex
              dish.dishIndex = dishIndex
              dish.periodPlanId = param.periodPlanId
              dish.tags.forEach(tag => {
                // 如果类目时间没有过期, 并有至少点的标签
                if (!utils.checkTimeReached(cate.cateEndTime) && tag.limitType === 1 && tag.checkType === 1) {
                  if (tag.userLeastAmount > 0) {
                    dish.count = tag.userLeastAmount
                    dish.userLeastAmount = tag.userLeastAmount
                    dish.decDisabled = true
                  }
                }
              })
            })
          })
          // 如果已经点过,则自动点上
          let selectedDish = getSelectedDish(state, param.periodPlanId)
          if (selectedDish.length > 0) {
            selectedDish.forEach(d => {
              dishes.forEach(cate => {
                if (!utils.checkTimeReached(cate.cateEndTime)) {
                  cate.items.forEach(dish => {
                    if (dish.itemId === d.itemId) {
                      dish.count = d.count
                      dish.addDisabled = d.addDisabled ? d.addDisabled : undefined
                      dish.decDisabled = d.decDisabled ? d.decDisabled : undefined
                    }
                  })
                }
              })
            })
          }
          commit(UPDATE_MENU_DISHES, {periodPlanId: param.periodPlanId, data: {dishes: dishes, discounts: discounts}})
          resolve()
        }, data => {
          commit(UPDATE_MENU_DISHES, {periodPlanId: param.periodPlanId, data: {}})
          reject(data)
        })
      })
    },
    // param: optr: 'd'(减操作) 'a'(加操作)
    //        periodPlanId
    //        cateIndex, dishIndex, count
    [CHANGE_DISH_COUNT] ({commit, state}, param) {
      return new Promise(function (resolve, reject) {
        let data = JSON.parse(JSON.stringify(state.allDishes))
        let periodPlanId = param.dish.periodPlanId
        let allDishes = data[periodPlanId]['dishes']
        let discounts = data[periodPlanId]['discounts']
        let discountDic = {}
        let cateIndex = param.dish.cateIndex
        let dishIndex = param.dish.dishIndex
        let cate = allDishes[cateIndex]
        let dish = allDishes[cateIndex].items[dishIndex]
        let needReject = false
        let rejectString = ''
        if (param.optr === 'a') { // 加操作
          // 库存
          if (param.count > dish.limit) {
            dish.addDisabled = true
            needReject = true
            rejectString = '超过库存限制'
          }
          // 类目预点限制
          if (utils.checkTimeReached(cate.cateEndTime)) {
            needReject = true
            rejectString = '该类目菜品超出预点时间'
          }
          // 单品限制
          let singleAmount = checkSingleDishLimitAmount(dish)
          if (singleAmount > 0) {
            if (param.count >= singleAmount) {
              dish.addDisabled = true
              if (param.count > singleAmount) {
                needReject = true
                rejectString = `${dish.itemName}限点${singleAmount}份`
              }
            }
          }
          // 范围限制
          let scopeCheckTips = checkScopeLimit(param, allDishes, dish)
          if (scopeCheckTips.length > 0) {
            commit(UPDATE_MENU_DISHES, {periodPlanId: periodPlanId, data: {dishes: allDishes, discounts: discounts}})
            needReject = true
            rejectString = scopeCheckTips
          }
        } else if (param.optr === 'd') {
          // 单品限制
          let singleAmount = checkSingleDishLeastAmount(dish)
          if (singleAmount > 0) {
            if (param.count <= singleAmount) {
              dish.decDisabled = true
              if (param.count < singleAmount) {
                needReject = true
                rejectString = `${dish.itemName}至少需点${singleAmount}份`
              }
            }
          }
          checkScopeLimit(param, allDishes, dish)
        }
        if (needReject) {
          reject(rejectString)
        } else {
          if (param.optr === 'a') {
            dish.decDisabled = false
          } else {
            dish.addDisabled = false
          }
          allDishes[cateIndex].items[dishIndex].count = param.count
          // 选择使用哪个优惠合适
          let selectFoods = []
          if (allDishes && allDishes.length > 0) {
            allDishes.forEach((good) => {
              good.items.forEach((food) => {
                if (food.count) {
                  selectFoods.push(food)
                }
              })
            })
          }
          // 将所有满足条件的优惠加入 discountArr 最后再做比较
          let discountArr = []
          if (discounts && discounts.length > 0) {
            discounts.forEach(discountItem => {
              if (discountItem.itemCategories !== undefined && discountItem.itemCategories.length > 0) {
                let boolArr = []
                discountItem.itemCategories.forEach(categoryItem => {
                  let bool = false
                  let cateArr = selectFoods.filter(selectFood => {
                    return categoryItem.itemCategoryId === selectFood.cateId
                  })
                  if (cateArr !== undefined && cateArr.length > 0) {
                    let dishCount = 0
                    cateArr.forEach(cateFood => {
                      dishCount += cateFood.count
                    })
                    console.log(cateArr)
                    console.log(dishCount)
                    if (dishCount >= categoryItem.amount) {
                      bool = true
                    } else {
                      bool = false
                    }
                  }
                  boolArr.push(bool)
                })
                let bool = boolArr.every(item => {
                  return item === true
                })
                if (bool) {
                  discountArr.push(discountItem)
                }
                boolArr.forEach(item => {
                  console.log(item)
                })
              } else {
                // type3 优惠 如果所点的菜的总价满足条件
                let totalPrice = 0
                selectFoods.forEach((food) => {
                  if (food.count) {
                    totalPrice += food.positionPrice * food.count
                  }
                })
                if (totalPrice > discountItem.totalPrice) {
                  discountArr.push(discountItem)
                }
              }
            })
            if (discountArr.length > 0) {
              let totalPrice = 0
              selectFoods.forEach((food) => {
                if (food.count) {
                  totalPrice += food.positionPrice * food.count
                }
              })
              let priceArr = []
              discountArr.forEach(item => {
                if (item.type === 1) {
                  priceArr.push({
                    discount: item.discount,
                    title: item.title,
                    hallItemDiscountInfoId: item.hallItemDiscountInfoId
                  })
                } else if (item.type === 2) {
                  priceArr.push({
                    discount: totalPrice - item.fixedPrice,
                    title: item.title,
                    hallItemDiscountInfoId: item.hallItemDiscountInfoId
                  })
                } else if (item.type === 3) {
                  priceArr.push({
                    discount: item.discount,
                    title: item.title,
                    hallItemDiscountInfoId: item.hallItemDiscountInfoId
                  })
                }
              })
              priceArr.sort(function (a, b) {
                return b.discount - a.discount
              })
              discountDic = priceArr[0]
              console.log(discountDic)
            }
          }
          commit(UPDATE_MENU_DISHES, {periodPlanId: periodPlanId, data: {dishes: allDishes, discounts}, discountDic})
          resolve()
        }
      })
    },
    // 确认订单的方法 reject 会返回错误提示
    // param:
    //        periodPlanId nutritionPeriodId
    [COMMIT_ORDER] ({commit, state}, param) {
      return new Promise(function (resolve, reject) {
        let needReject = false
        let rejectString = ''
        let allowForceCommit = true
        // let allDishes = JSON.parse(JSON.stringify(state.allDishes))
        let data = JSON.parse(JSON.stringify(state.allDishes))
        // let periodPlanId = param.periodPlanId
        // let allDishes = data[periodPlanId]['dishes']
        // 检查单个菜品 提醒点
        let singleDishRemind = checkSingleDishRemind(param, data)
        if (singleDishRemind.length > 0) {
          needReject = true
          rejectString = singleDishRemind
          allowForceCommit = true
        }
        // 检查范围菜品 提醒点
        let scopeDishRemind = checkScopeDishRemind(param, data)
        if (scopeDishRemind.length > 0) {
          needReject = true
          rejectString = scopeDishRemind
          allowForceCommit = true
        }
        // 范围限制 (检查范围限制的"至少点")
        let scopeCheckTips = checkScopeLeast(param, data)
        if (scopeCheckTips.length > 0) {
          needReject = true
          rejectString = scopeCheckTips
          allowForceCommit = false
        }
        if (needReject) {
          reject({string: rejectString, allowForceCommit: allowForceCommit})
        } else {
          resolve()
        }
      })
    },
    [CLEAR_ORDERED_DISH_BY_PERIOD_ID] ({commit, state}, periodPlanId) {
      let data = JSON.parse(JSON.stringify(state.allDishes))
      if (data[periodPlanId] !== undefined) {
        let dishes = data[periodPlanId]['dishes']
        let discounts = data[periodPlanId]['discounts']
        dishes.forEach(cate => {
          if (cate.items.length > 0) {
            cate.items.forEach(i => {
              i.decDisabled = false
              i.addDisabled = false
              if (!i.userLeastAmount || i.userLeastAmount <= 0) {
                i.count = 0
              }
            })
          }
        })
        commit(UPDATE_MENU_DISHES, {periodPlanId: periodPlanId, data: {dishes: dishes, discounts: discounts}})
        // commit(UPDATE_MENU_DISHES, {periodPlanId: periodPlanId, data: dishes})
      }
    }
  }
}

// 检查单个菜品 提醒点
function checkSingleDishRemind (param, allDishes) {
  let tips = ''
  let commonDishes = allDishes[param.periodPlanId]['dishes']
  let nutritionDishes = allDishes[param.nutritionPeriodId]
  console.log(commonDishes)
  commonDishes.forEach(cate => {
    cate.items.forEach(dish => {
      dish.tags.forEach(tag => {
        if (tag.limitType === 3 && tag.checkType === 1) {
          // 如果没点这个菜, 就返回 tip
          if (dish.count === undefined || dish.count === 0) {
            if (tips.length > 0) {
              tips = `${tips}、"${dish.itemName}"`
            } else {
              tips = `您还没有点"${dish.itemName}"`
            }
          }
        }
      })
    })
  })
  if (Array.isArray(nutritionDishes) && nutritionDishes.length > 0) {
    nutritionDishes.forEach(cate => {
      cate.items.forEach(dish => {
        dish.tags.forEach(tag => {
          if (tag.limitType === 3 && tag.checkType === 1) {
            // 如果没点这个菜, 就返回 tip
            if (dish.count === undefined || dish.count === 0) {
              if (tips.length > 0) {
                tips = `${tips}、"${dish.itemName}"`
              } else {
                tips = `您还没有点"${dish.itemName}"`
              }
            }
          }
        })
      })
    })
  }
  if (tips.length > 0) {
    tips = `${tips}，是否确认结算？`
  }
  return tips
}
// 检查范围菜品 提醒点
function checkScopeDishRemind (param, allDishes) {
  let tips = ''
  let map = makeTagDishMap(allDishes[param.periodPlanId]['dishes'], 3, 2)
  for (let [tag, dishes] of map.entries()) {
    let totalCount = dishes.reduce((acc, cur) => {
      return acc + cur.count
    }, 0)
    if (totalCount === 0) {
      if (tips.length === 0) {
        tips = `您还没有点"${tag.tagName}"`
      } else {
        tips = `${tips}\n您还没有点"${tag.tagName}"`
      }
    }
  }
  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 3, 2)
  for (let [tag, dishes] of map.entries()) {
    let totalCount = dishes.reduce((acc, cur) => {
      return acc + cur.count
    }, 0)
    if (totalCount === 0) {
      if (tips.length === 0) {
        tips = `您还没有点"${tag.tagName}"`
      } else {
        tips = `${tips};
        您还没有点"${tag.tagName}"`
      }
    }
  }
  if (tips.length > 0) {
    tips = `${tips}，是否确认结算？`
  }
  return tips
}
// 检查单个菜品的最多点
function checkSingleDishLimitAmount (dish) {
  let result = 999
  dish.tags.forEach(tag => {
    if (tag.limitType === 1 && tag.checkType === 1) {
      if (tag.userLimitAmount < result) {
        result = tag.userLimitAmount
      }
    }
  })
  return result
}
// 检查单个菜品的至少点
function checkSingleDishLeastAmount (dish) {
  let result = 0
  dish.tags.forEach(tag => {
    if (tag.limitType === 1 && tag.checkType === 1) {
      if (tag.userLeastAmount !== 0 && tag.userLeastAmount > result) {
        result = tag.userLeastAmount
      }
    }
  })
  return result
}
// 生成 tag 和 包含该 tag 的菜品对应的 map, 结构为 {tag1:[dish1,dish2...], tag2:[dish2,dish3...]}
function makeTagDishMap (allDishes, limitType, checkType) {
  if (!Array.isArray(allDishes) || allDishes.length === 0) {
    return new Map()
  }
  let map = new Map()
  let set = new Set()
  allDishes.forEach(cate => {
    cate.items.forEach(dish => {
      dish.tags.forEach(tag => {
        if (tag.limitType === limitType && tag.checkType === checkType) {
          let exist = false
          for (let item of set.values()) {
            if (item.tagId === tag.tagId) {
              exist = true
            }
          }
          if (exist === false) {
            set.add(tag)
          }
        }
      })
    })
  })
  for (let item of set.values()) {
    let dishArr = []
    allDishes.forEach(cate => {
      cate.items.forEach(dish => {
        dish.tags.forEach(tag => {
          if (tag.tagId === item.tagId) {
            dishArr.push(dish)
          }
        })
      })
    })
    map.set(item, dishArr)
  }
  return map
}
// 检查范围限制
// param: optr: 'd'(减操作) 'a'(加操作)
//        periodPlanId
function checkScopeLimit (param, allDishes, origDish) {
  let map = makeTagDishMap(allDishes, 1, 2)
  let tips = ''
  if (param.optr === 'a') {
    let canBeAddCount = true
    origDish.tags.forEach(dishTag => {
      for (let [tag, dishes] of map.entries()) {
        if (dishTag.tagId === tag.tagId) {
          let totalCount = dishes.reduce((acc, cur) => {
            return acc + cur.count
          }, 0)
          if (totalCount > tag.userLimitAmount - 1) {
            canBeAddCount = false
            tips = `"${tag.tagName}"类菜品数量不可超过${tag.userLimitAmount}份`
          } else if (totalCount === tag.userLimitAmount - 1) {
            dishes.forEach(dish => {
              dish.addDisabled = true
            })
          }
        }
      }
    })
    if (canBeAddCount) {
      origDish.count++
    }
  } else if (param.optr === 'd') {
    origDish.tags.forEach(dishTag => {
      for (let [tag, dishes] of map.entries()) {
        if (dishTag.tagId === tag.tagId) {
          dishes.forEach(dish => {
            dish.addDisabled = false
          })
        }
      }
    })
  }
  return tips
}
function checkScopeLeast (param, allDishes) {
  let tips = ''
  let map = makeTagDishMap(allDishes[param.periodPlanId]['dishes'], 1, 2)
  for (let [tag, dishes] of map.entries()) {
    let totalCount = dishes.reduce((acc, cur) => {
      return acc + cur.count
    }, 0)
    if (totalCount < tag.userLeastAmount) {
      tips = `"${tag.tagName}"类菜品数量至少点${tag.userLeastAmount}份`
    }
  }
  map = makeTagDishMap(allDishes[param.nutritionPeriodId], 1, 2)
  for (let [tag, dishes] of map.entries()) {
    let totalCount = dishes.reduce((acc, cur) => {
      return acc + cur.count
    }, 0)
    if (totalCount < tag.userLeastAmount) {
      tips = `"${tag.tagName}"类菜品数量至少点${tag.userLeastAmount}份`
    }
  }
  return tips
}
function getSelectedDish (state, periodPlanId) {
  let selectedDish = []
  if (state.allDishes[periodPlanId] === undefined || !Array.isArray(state.allDishes[periodPlanId])) return []
  state.allDishes[periodPlanId].forEach(cate => {
    cate.items.forEach(dish => {
      if (dish.count > 0) {
        selectedDish.push(dish)
      }
    })
  })
  return JSON.parse(JSON.stringify(selectedDish))
}



// WEBPACK FOOTER //
// ./src/store/period.js